import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome'

class KeyboardKey extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pressed: false,
            canpress: true,
        }

    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
        }
    }

    handlePress() {
        if (this.state.canpress === true) {
            this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
            this.setState({
                pressed: true,
                canpress: false
            })
            this.timeout = setTimeout(() => {
                this.setState({
                    pressed: false,
                    canpress: true
                })
                this.timeout = null
            }, 125)

        }

    }

    render() {
        let classes = "pressin keyopacity";
        if (this.state.pressed === true) {
            classes += " active"
        }
        if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
            classes += " keyhide"
            return (
                // <div style={{display: 'hidden'}}><div style={this.props.mainstyle[1]} className={classes}><span className="kspn">&nbsp;</span></div></div>
                <div style={this.props.mainstyle} className={classes}><span className="kspn">&nbsp;</span></div>
            )
        }
        classes += " phand"
        let innercontent;
        switch (this.props.contents[this.props.virtual_keyboard_mode]) {
            case "UPCASE":
                innercontent = <FontAwesome name='arrow-circle-o-up' />//<Icon type="up-circle-o" />
                break;
            case "DOWNCASE":
                innercontent = <FontAwesome name='arrow-circle-o-down' />//<Icon type="down-circle-o" />
                break;
            case "DELETE":
                innercontent = <FontAwesome name='arrow-circle-o-left' />//<Icon type="left" />
                break;
            default:
                innercontent = this.props.contents[this.props.virtual_keyboard_mode];
                break;
        }

        return (
            <div onMouseDown={(e) => this.handlePress(e)} style={this.props.mainstyle} className={classes}><span className="kspn">{innercontent}</span></div>
        )

    }
}

export default KeyboardKey;


// WEBPACK FOOTER //
// ./src/Components/UserInput/KeyboardKey.js